import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <button style={styles.backBtn} onClick={() => navigate(-1)}>
                    &larr; Back
                </button>
                <h1 style={styles.title}>Privacy Policy</h1>
            </div>
            
            <div style={styles.content}>
                <p><strong>Effective as of April 23, 2026</strong></p>

                <p>
                    This Privacy Policy ("Policy") applies to Copper Road Experiences, and ABV Network, LLC ("Company") 
                    and governs data collection and usage. For the purposes of this Policy, unless otherwise noted, all references 
                    to the Company include copperroadexperiences.com/.net only and no other websites or subsidiaries of ABV Network, 
                    LLC. The Company application is a ecommerce application. By using the Company application, you consent to the 
                    data practices described in this statement.
                </p>

                <h2>I. Collection of Your Personal Information</h2>
                <p>
                    In order to better provide you with products and services offered, the Company may collect personally identifiable 
                    information, such as your:
                </p>
                <ul>
                    <li>First and last name</li>
                    <li>Mailing address</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Shirt Size</li>
                </ul>
                <p>
                    We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be 
                    required to provide certain personal information to us when you elect to use certain products or services. These 
                    may include: (a) registering for an account; (b) entering a sweepstakes or contest sponsored by us or one of our 
                    partners; (c) signing up for special offers from selected third parties; (d) sending us an email message; (e) 
                    submitting your credit card or other payment information when ordering and purchasing products and services. To 
                    wit, we will use your information for, but not limited to, communicating with you in relation to services and/or 
                    products you have requested from us. We may also gather additional personal or non-personal information in the future.
                </p>

                <h2>II. Use of your Personal Information</h2>
                <p>The Company collects and uses your personal information in the following ways:</p>
                <ul>
                    <li>to operate and deliver the services you have requested.</li>
                    <li>to provide you with information, products, or services that you request from us.</li>
                    <li>to provide you with notices about your account.</li>
                    <li>to carry out the Company's obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection.</li>
                    <li>to notify you about changes to our Copper Road Experiences application or any products or services we offer or provide through it.</li>
                    <li>to maintain the security of the Company's services and prevent fraud or misuse.</li>
                    <li>to comply with applicable laws, regulations, legal processes, or governmental requests.</li>
                    <li>To record a unique history of experiences visited and to provide reward(s) upon completing each set of experiences.</li>
                    <li>in any other way we may describe when you provide the information.</li>
                    <li>for any other purpose with your consent.</li>
                </ul>
                <p>
                    The Company may also use your personally identifiable information to inform you of other products or services 
                    available from the Company and its affiliates.
                </p>

                <h2>III. Sharing Information with Third Parties</h2>
                <p>
                    The Company does not sell, rent, or lease its customer lists to third parties.
                </p>
                <p>
                    The Company may, from time to time, contact you on behalf of external business partners about a particular 
                    offering that may be of interest to you. In those cases, your unique personally identifiable information (email, 
                    name, address, phone number) is transferred to the third party.
                </p>
                <p>
                    The Company does not sell biometric data to third parties.
                </p>
                <p>
                    The Company may share data with trusted partners to help perform statistical analysis, send you email or postal 
                    mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your 
                    personal information except to provide these services to the Company, and they are required to maintain the 
                    confidentiality of your information.
                </p>
                <p>
                    The Company may disclose your personal information, without notice, if required to do so by law or in the good 
                    faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served 
                    on the Company or the site; (b) protect and defend the rights or property of the Company; and/or (c) act under 
                    exigent circumstances to protect the personal safety of users of the Company, or the public.
                </p>

                <h2>IV. Opt-Out of Disclosure of Personal Information to Third Parties</h2>
                <p>
                    In connection with any personal information we may disclose to a third party for a business purpose, you have the 
                    right to know:
                </p>
                <ul>
                    <li>The categories of personal information that we disclosed about you for a business purpose.</li>
                </ul>
                <p>
                    You have the right under the California Consumer Privacy Act of 2018 (CCPA) and certain other privacy and data 
                    protection laws, as applicable, to opt out of the sale or disclosure of your personal information. If you exercise your 
                    right to opt out of the sale or disclosure of your personal information, we will refrain from selling or 
                    disclosing your personal information, unless you subsequently provide express authorization for the sale or 
                    disclosure of your personal information. To opt out of the sale or disclosure of your personal information, send a 
                    written request via email to privacy@copperroadexperiences.com.
                </p>

                <h2>V. Right to Deletion</h2>
                <p>
                    Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:
                </p>
                <ul>
                    <li>Delete your personal information from our records; and</li>
                    <li>Direct any service providers to delete your personal information from their records.</li>
                </ul>
                <p>
                    Please note that we may not be able to comply with requests to delete your personal information if it is necessary to:
                </p>
                <ul>
                    <li>Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, and provide a good or service requested by you, or reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between you and us;</li>
                    <li>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that activity;</li>
                    <li>Debug to identify and repair errors that impair existing intended functionality;</li>
                    <li>Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law;</li>
                    <li>Comply with the California Electronic Communications Privacy Act;</li>
                    <li>Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when our deletion of the information is likely to render impossible or seriously impair the achievement of such research, provided we have obtained your informed consent;</li>
                    <li>Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;</li>
                    <li>Comply with an existing legal obligation; or</li>
                    <li>Otherwise, use your personal information internally in a lawful manner that is compatible with the context in which you provided the information.</li>
                </ul>

                <h2>VI. Data Security and Breach Notification</h2>
                <p>
                    The Company maintains reasonable administrative, technical, and physical safeguards designed to protect personal 
                    information from unauthorized access, acquisition, disclosure, or use. In the event of a security incident involving 
                    personal information, the Company will promptly investigate the incident and provide notice to affected individuals 
                    and, where required, to applicable regulatory authorities in accordance with applicable law. The Company will provide any required notice in the manner and within the timeframes prescribed by applicable law.
                </p>

                <h2>VII. Children Under 13</h2>
                <p>
                    The Company does not knowingly collect personally identifiable information from children under the age of thirteen. 
                    If you are under the age of 13, you must ask your parent or guardian for permission to use this platform.
                </p>

                <h2>VIII. Disconnecting Your Company Account From Third-Party Websites</h2>
                <p>
                    You will be able to connect your Company account to third-party accounts. BY CONNECTING YOUR COMPANY ACCOUNT 
                    TO YOUR THIRD-PARTY ACCOUNT, YOU ACKNOWLEDGE AND AGREE THAT YOU ARE CONSENTING TO THE CONTINUOUS RELEASE 
                    OF INFORMATION ABOUT YOU TO OTHERS (IN ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE THIRD-PARTY SITES). 
                    IF YOU DO NOT WANT INFORMATION ABOUT YOU, INCLUDING PERSONALLY IDENTIFYING INFORMATION, TO BE SHARED IN THIS 
                    MANNER, DO NOT USE THIS FEATURE. You may disconnect your account from a third-party account at any time. Users 
                    may learn how to disconnect their accounts from third-party websites by visiting their accounts at the third-party website 
                    (i.e. Google or Apple). Users may also contact us via email at privacy@copperroadexperiences.com.
                </p>

                <h2>IX. Opt-Out & Unsubscribe From Third-Party Communications</h2>
                <p>
                    We respect your privacy and give you an opportunity to opt out of receiving announcements of certain information. 
                    Users may opt out of receiving any or all communications from third-party partners of the Company by contacting us here:
                </p>
                <ul>
                    <li>Email: privacy@copperroadexperiences.com</li>
                </ul>

                <h2>X. Email Communications</h2>
                <p>
                    From time to time, the Company may contact you via email for the purpose of providing announcements, 
                    promotional offers, alerts, confirmations, surveys, and/or other general communication. In order to improve our 
                    services, we may receive a notification when you open an email from the Company or click on a link therein.
                </p>
                <p>
                    If you would like to stop receiving marketing or promotional communications via email from the Company, you 
                    may opt out of such communications by clicking on the unsubscribe button within the email that was sent.
                </p>

                <h2>XI. External Data Storage Sites</h2>
                <p>
                    We may store your data on servers provided by third-party hosting vendors with whom we have contracted.
                </p>

                <h2>XII. Changes to This Statement</h2>
                <p>
                    The Company reserves the right to change this Policy from time to time. For example, when there are changes in 
                    our services, changes in our data protection practices, or changes in the law. When changes to this Policy are 
                    significant, we will inform you. You may receive a notice by sending an email to the primary email address 
                    specified in your account, by placing a prominent notice on our application, and/or by updating any privacy 
                    information. Your continued use of the application and/or services available after such modifications will constitute 
                    your: (a) acknowledgment of the modification of this Policy; and (b) agreement to abide and be bound by this modified Policy.
                </p>

                <h2>XIII. Contact Information</h2>
                <p>
                    The Company welcomes your questions or comments regarding this Statement of Privacy. If you believe that the 
                    Company has not adhered to this Statement, please contact the Company at:
                </p>
                <p>
                    ABV Network, LLC<br />
                    3113 Lakeview Park Circle<br />
                    St. Louis, Missouri 63129
                </p>
                <p>
                    Email Address:<br />
                    privacy@copperroadexperiences.com
                </p>
                <p>
                    Phone number:<br />
                    3144095216
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        background: '#fff',
        minHeight: '100vh',
        fontFamily: "'Inter', sans-serif",
        padding: '40px 20px',
        color: '#333'
    },
    header: {
        maxWidth: 800,
        margin: '0 auto 40px',
        display: 'flex',
        alignItems: 'center',
        gap: 20
    },
    backBtn: {
        background: 'none',
        border: 'none',
        color: '#B87333',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 'bold',
        padding: 0
    },
    title: {
        fontSize: '32px',
        fontFamily: 'Georgia, serif',
        color: '#1a2234',
        margin: 0
    },
    content: {
        maxWidth: 800,
        margin: '0 auto',
        lineHeight: 1.8,
        fontSize: '16px'
    }
};
